import React from "react";
import { StatusBadge } from "../../../../shared/components/badges/StatusBadge";
import { ExpandedAccordion } from "../../../../shared/components/ui/ExpandedAccordion";

const VillageExpandRow = ({ item }) => {
  const sections = [
    {
      id: "basic",
      title: "Village Information",
      fields: [
        { label: "Taluka", value: item.taluka?.name || "—" },
        { label: "District", value: item.district?.name || item.taluka?.district?.name || "—" },
        { label: "Postal Code", value: item.postalCode || "—" },
        {
          label: "Created Date",
          value: item.createdAt
            ? new Date(item.createdAt).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })
            : "—",
        },
      ],
    },
    {
      id: "contact",
      title: "Contact Information",
      fields: [
        { label: "Contact Person", value: item.contactPerson || "—" },
        { label: "Phone Number", value: item.phone || "—" },
        { label: "Email", value: item.email || "—" },
        { label: "Office Address", value: item.officeAddress || "—", isLong: true },
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default VillageExpandRow;
